import { render, staticRenderFns } from "./StockOverview.vue?vue&type=template&id=2989254b"
import script from "./StockOverview.vue?vue&type=script&lang=ts"
export * from "./StockOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports